import React, { createContext, useContext, useState, useEffect } from 'react';
import adminApi from '../api/adminAxios';

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
    // admin_name in localStorage is used as the session indicator (App.js reads it).
    // email and role are NOT stored — fetched from /admin/me on mount instead.
    const [admin, setAdmin] = useState(() => {
        const name = localStorage.getItem('admin_name');
        return name ? { name } : null;
    });

    // Fetch fresh admin data (including email & role) from the server on every load.
    // This ensures stale/tampered localStorage values are always overwritten.
    useEffect(() => {
        if (!localStorage.getItem('admin_name')) return;
        adminApi.get('/admin/me')
            .then((res) => {
                const data = res.data.data ?? res.data;
                setAdmin(data);
                // Keep name in localStorage so App.js route guard works across refreshes
                if (data?.name) localStorage.setItem('admin_name', data.name);
            })
            .catch(() => {
                // Session expired — clear and force re-login
                localStorage.removeItem('admin_name');
                setAdmin(null);
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const login = (adminData) => {
        // Store only the display name — never email or role
        localStorage.setItem('admin_name', adminData.name);
        setAdmin(adminData);
    };

    const logout = () => {
        localStorage.removeItem('admin_name');
        setAdmin(null);
    };

    const isAuthenticated = () => !!admin;

    return (
        <AdminAuthContext.Provider value={{ admin, login, logout, isAuthenticated }}>
            {children}
        </AdminAuthContext.Provider>
    );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
